module.exports = __webpack_public_path__ + "static/service-section-img-00bc1d0411b44d66c6163b8513da4317.png";